
export interface ResourceData {
  id: number;
  title: string;
  description: string;
  category: string;
  isPremium: boolean;
  link: string;
  readTime: string;
  readCount: number;
  likeCount: number;
  comingSoon?: boolean;
  isPreviewEnabled?: boolean;
  featured?: boolean;
}

export const categories = [
  "All",
  "ML Fundamentals",
  "System Design Case Studies",
  "Interactive Playground"
];

export const resources: ResourceData[] = [
  {
    id: 1,
    title: "How to Crack ML Interviews at FAANG",
    description: "Cracking a machine learning interview at companies like Facebook, Google, Netflix, Snap etc. really comes down to nailing few patterns that these companies look for. In this article, I plan to share my experience interviewing with these companies and also how I went about preparing.",
    category: "ML Fundamentals",
    isPremium: false,
    link: "/articles/faang-ml-interviews",
    readTime: "12 min read",
    readCount: 1256,
    likeCount: 341,
    isPreviewEnabled: true
  },
  {
    id: 2,
    title: "Level Up Your FAANG ML Interview – Tips for IC2 to IC6",
    description: "This document outlines advanced pointers for ML interviews at FAANG companies, specifically tailored for Junior and Senior Staff positions. Building upon Part 1, we delve deeper into system design challenges and architectural considerations.",
    category: "ML Fundamentals",
    isPremium: true,
    link: "/articles/faang-ml-interviews-part2",
    readTime: "15 min read",
    readCount: 984,
    likeCount: 278,
    isPreviewEnabled: false
  },
  {
    id: 3,
    title: "Framework for Recommendation System problems",
    description: "If you are applying for ML generalist roles at top companies like Facebook, Google, Netflix etc, most of the questions are going to be of the flavor of 'design a recommendation system for X'. While the context and constraints differ, the backbone remains common.",
    category: "ML Fundamentals",
    isPremium: true,
    link: "/articles/recommendation-systems",
    readTime: "15 min read",
    readCount: 0,
    likeCount: 0,
    comingSoon: false,
    isPreviewEnabled: false
  },
  {
    id: 7,
    title: "All about Ads calibration",
    description: "Understand techniques for calibrating ads models to improve fairness and accuracy.",
    category: "ML Fundamentals",
    isPremium: true,
    link: "/articles/ads-calibration",
    readTime: "15 min read",
    readCount: 0,
    likeCount: 0,
    comingSoon: false,
    isPreviewEnabled: false,
    featured: true
  },
  {
    id: 14,
    title: "Biases in recommender systems",
    description: "This article explores four common biases: Sample Selection Bias, Popularity Bias, Position Bias, and Temporal Bias. We'll walk through each bias with examples and discuss how to address them in real systems.",
    category: "ML Fundamentals",
    isPremium: true,
    link: "/articles/biases",
    readTime: "10 min read",
    readCount: 0,
    likeCount: 0,
    comingSoon: false,
    isPreviewEnabled: false,
    featured: false
  },
  {
    id: 13,
    title: "Evolution of Candidate generation algorithms",
    description: "Candidate generation is the 'first filter' in a two-stage recommender: instead of scoring every item in a huge catalog, it rapidly narrows billions (or millions) of products, videos, or posts down to a few hundred–thousand candidates in real time.",
    category: "ML Fundamentals",
    isPremium: true,
    link: "/articles/candidate-generation",
    readTime: "25 min read",
    readCount: 0,
    likeCount: 0,
    comingSoon: false,
    isPreviewEnabled: false,
    featured: false
  },
  {
    id: 4,
    title: "Design a YouTube Homepage Recommendation System",
    description: "This document outlines an end-to-end design for a YouTube Homepage Recommendation System. With billions of videos in the catalog, a high query rate (~10K QPS), and strict sub-50 ms inference constraints, this system must deliver highly personalized content to logged-in users.",
    category: "System Design Case Studies",
    isPremium: true,
    link: "/articles/youtube-recommendation-system",
    readTime: "18 min read",
    readCount: 9758,
    likeCount: 478,
    comingSoon: false,
    isPreviewEnabled: false,
    featured: false
  },
  {
    id: 5,
    title: "Design a Harmful Content Detection System",
    description: "A comprehensive approach to detecting and managing harmful content types including misinformation, hate speech, borderline content, and illegal content.",
    category: "System Design Case Studies",
    isPremium: true,
    link: "/articles/harmful-content-detection",
    readTime: "20 min read",
    readCount: 0,
    likeCount: 0,
    comingSoon: false,
    isPreviewEnabled: false
  },
  {
    id: 6,
    title: "How to Build and Serve User Embeddings",
    description: "Learn techniques for creating and deploying effective user embeddings for recommendation systems.",
    category: "ML Fundamentals",
    isPremium: true,
    link: "/learn/user-embeddings",
    readTime: "20 min read",
    readCount: 0,
    likeCount: 0,
    comingSoon: true,
    isPreviewEnabled: false
  },
  {
    id: 8,
    title: "Design an Ads recommendation system",
    description:
      "This article provides an overview of designing an Ads ranking system for Facebook, focusing specifically on Instagram Feed, covering everything from system architecture to handling position bias and cold starts.\n\nThe article breaks down core components like targeting, ranking, pricing, and user experience, with special emphasis on how an E6/Staff engineer might approach this ML design.",
    category: "System Design Case Studies",
    isPremium: true,
    link: "/articles/ads-ranking",
    readTime: "30 min read",
    readCount: 0,
    likeCount: 0,
    comingSoon: false,
    isPreviewEnabled: false,
    featured: false
  },
  {
    id: 9,
    title: "On-the-Fly Personalization at Meta",
    description: "How to build ML systems that adapt to user behavior within a single session using sequence modeling.",
    category: "System Design Case Studies",
    isPremium: true,
    link: "/articles/user-behaviour-sequence-modelling",
    readTime: "10 min read",
    readCount: 0,
    likeCount: 0,
    comingSoon: false,
    isPreviewEnabled: false
  },
  {
    id: 10,
    title: "Introduction to Continual Personalization",
    description: "Design patterns for implementing personalization systems that continuously learn and adapt.",
    category: "System Design Case Studies",
    isPremium: true,
    link: "/learn/continual-personalization",
    readTime: "22 min read",
    readCount: 0,
    likeCount: 0,
    comingSoon: true,
    isPreviewEnabled: false
  },
  {
    id: 11,
    title: "Building a Restaurant Delivery System",
    description: "End-to-end ML system design for optimizing food delivery logistics and recommendations.",
    category: "System Design Case Studies",
    isPremium: true,
    link: "/learn/restaurant-delivery",
    readTime: "28 min read",
    readCount: 0,
    likeCount: 0,
    comingSoon: true,
    isPreviewEnabled: false
  },
  {
    id: 12,
    title: "Building a Rider Pricing ML System",
    description: "Designing ML systems for dynamic pricing in ride-sharing applications.",
    category: "System Design Case Studies",
    isPremium: true,
    link: "/learn/rider-pricing",
    readTime: "26 min read",
    readCount: 0,
    likeCount: 0,
    comingSoon: true,
    isPreviewEnabled: false
  }
];
